import {XauditModel} from '../xaudit.model';
import {DocumentTagDataModel} from './document-tag-data.model';

export class DocumentDataModel extends XauditModel {
  DocumentID: string;
  LOCID: number;
  PatientId: string;
  PatientCaseId: string;
  CaseWorkItemId: string;
  WorkItemEventId: string;
  Description: string;
  DocumentCreateDate: Date;
  DocumentModifiedDate: Date;
  DocumentFileName: string;
  enumDocumentFileTypeID: string;
  enumDocumentTypeID: string;
  enumDocumentClassID: string;
  DocumentOrder: string;
  ParentDocumentID: string;
  ImageSpreadPKID: number;
  PhysicalFileName: string;
  dataDocumentTags: DocumentTagDataModel[];
  hasAnnotation: boolean;
  DeviceID: string;
  listOfTeeth: string;
  caseName: string;
}
